module.exports = __webpack_public_path__ + "img/dreamer.acf07676.svg";